export const isShowLogo = (width: number): boolean => {
  if (width <= 1024) return true;
  return false;
};
